import React, { useState } from 'react';
import './HamburgerMenu.css';
import { Link } from "react-router-dom";
import Axios from 'axios'
import { Host } from '../App';

function HamburgerMenu(props) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const hide = () => {
    setIsSidebarOpen(false)
  }

  const handleLogout = () => {
    window.localStorage.removeItem("acessToken");
    window.localStorage.removeItem("Name");
    window.localStorage.removeItem("token");
    window.localStorage.removeItem("Rank");
    window.localStorage.removeItem("Stage");
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
    Axios.get(`https://` + Host + `/logout`).then((data) => {
      console.log(data);
      props.history.push('/');
    })
    setIsSidebarOpen(false)
  }
  return (
    <div className="ThreelinesApp">
      <div className="hamburger" onClick={toggleSidebar}>
        <div className="line"></div>
        <div className="line"></div>
        <div className="line"></div>
      </div>

      <nav className={`sidebar_hamburger ${isSidebarOpen ? 'open' : ''}`}>
        <ul className="hamburgermenu">
          <li className="hamburgermenu-item">
            <Link to="/NewDashboard" onClick={hide}>DASHBOARD</Link>
          </li>
          <li className="hamburgermenu-item">
            <Link to="/adddata" onClick={hide}>PO DATA</Link>
          </li>
          <li className="hamburgermenu-item">
            <Link to="/openorder" onClick={hide}>OPEN ORDERS</Link>
          </li>
          <li className="hamburgermenu-item">
            <Link to="/Pivot" onClick={hide}>PIVOT</Link>
          </li>
          <li className="hamburgermenu-item">
            <Link to="/suppluchain" onClick={hide}>SUPPLY CHAIN</Link>
          </li>
          <li className="hamburgermenu-item">
            <Link to="/attendance" onClick={hide}>ATTENDANCE PORTAL</Link>
          </li>
          <li className="hamburgermenu-item">
            <Link to="/Scheduling" onClick={hide}>SCHEDULING</Link>
          </li>
          <li className="hamburgermenu-item">
            <Link to="/BOM" onClick={hide}>BOM</Link>
          </li>
          <li className="hamburgermenu-item">
            <Link to="/Maintenance" onClick={hide}>MAINTENANCE</Link>
          </li>
          <li className="hamburgermenu-item">
            <Link to="/Woodshop_Dashboard" onClick={hide}>WOODSHOP</Link>
          </li>
          <li className="hamburgermenu-item">
            <Link to="/PurchaseRequest" onClick={hide}>PURCHASE REQUEST</Link>
          </li>
          <li className="hamburgermenu-item">
            <a href="/" onClick={handleLogout}>
              LOGOUT
            </a>
          </li>
        </ul>
      </nav>

      {/* Add the rest of your app content here */}
    </div>
  );
}


export default HamburgerMenu;
